import { render, staticRenderFns } from "./juridicalPersonData.vue?vue&type=template&id=60fec9ab&scoped=true&"
import script from "./juridicalPersonData.vue?vue&type=script&lang=js&"
export * from "./juridicalPersonData.vue?vue&type=script&lang=js&"
import style0 from "./juridicalPersonData.vue?vue&type=style&index=0&id=60fec9ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fec9ab",
  null
  
)

export default component.exports